<template>
  <div class="user">
    <basic-container>
      <avue-crud
        :option="option"
        ref="crud"
        v-model="form"
        :page.sync="page"
        @on-load="getList"
        @size-change="sizeChange"
        @current-change="currentChange"
        :table-loading="listLoading"
        @search-change="handleFilter"
        @refresh-change="handleRefreshChange"
        @row-update="update"
        @row-save="create"
        :before-open="handleOpenBefore"
        :data="list"
      >
        <template slot="menuLeft">
          <el-button
            v-if="sys_user_add"
            class="filter-item"
            @click="$refs.crud.rowAdd()"
            type="primary"
            icon="el-icon-edit"
          >
            添加
          </el-button>
        </template>
        <template slot="username" slot-scope="scope">
          <span>{{ scope.row.username }}</span>
        </template>
        <template slot="role" slot-scope="scope">
          <span v-for="(role, index) in scope.row.roleList" :key="index">
            <el-tag>{{ role.roleName }}</el-tag>
            &nbsp;&nbsp;
          </span>
        </template>
        <template slot="deptId" slot-scope="scope">
          {{ scope.row.deptName }}
        </template>
        <template slot="lockFlag" slot-scope="scope">
          <el-tag>{{ scope.label }}</el-tag>
        </template>
        <template slot="menu" slot-scope="scope">
          <el-button
            v-if="sys_user_edit"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row, scope.index)"
          >
            编辑
          </el-button>
          <el-button
            v-if="sys_user_del"
            type="text"
            icon="el-icon-delete"
            @click="deletes(scope.row, scope.index)"
          >
            删除
          </el-button>
        </template>
        <template slot="deptIdForm" slot-scope="scope">
          <avue-input-tree
            v-model="form.deptId"
            placeholder="请选择所属部门"
            :node-click="getNodeData"
            :dic="treeDeptData"
            :props="defaultProps"
          ></avue-input-tree>
        </template>
        <template slot="roleForm" slot-scope="scope">
          <avue-select
            v-model="role"
            multiple
            placeholder="请选择角色"
            :dic="rolesOptions"
            :props="roleProps"
          ></avue-select>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { addObj, delObj, fetchList, putObj } from '@/api/admin/user';
import {
  insertTrAbilityQc,
  checkTrAbilityQc,
  deleteTrAbilityQc,
} from '@/api/dot/qc';
import { statistics } from '@/api/dot/flow';
import { deptRoleList } from '@/api/admin/role';
import { fetchTree } from '@/api/admin/dept';
import { tableOption } from '@/const/crud/admin/user';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'table_user',
  data() {
    return {
      currentStaffId: '',
      option: tableOption,
      treeDeptData: [],
      checkedKeys: [],
      roleProps: {
        label: 'roleName',
        value: 'roleId',
      },
      defaultProps: {
        label: 'name',
        value: 'id',
      },
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条,
        isAsc: false, //是否倒序
      },
      list: [],
      listLoading: true,
      role: [],
      form: {},
      rolesOptions: [],
      staParams: null,
    };
  },
  computed: {
    ...mapGetters(['permissions']),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  watch: {
    role() {
      this.$set(
        this.option.column[6],
        'addDisplay',
        !!this.role.find((it) => it === 13),
      );
      this.$set(
        this.option.column[6],
        'editDisplay',
        !!this.role.find((it) => it === 13),
      );
      this.form.role = this.role;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.curPath = to.path;
      vm.oldPath = from.path;
    });
  },
  created() {
    this.sys_user_add = this.permissions['sys_user_add'];
    this.sys_user_edit = this.permissions['sys_user_edit'];
    this.sys_user_del = this.permissions['sys_user_del'];
  },
  mounted() {
    this.staParams = {
      u_id: this.userInfo.staffId,
      time: new Date().getTime(),
      browser: navigator.userAgent.toLowerCase(),
      url: document.URL,
      scene_name: '用户管理',
    };
    this.statistics();
  },
  methods: {
    statistics() {
      statistics(
        Object.assign(
          {
            event_type: 'view',
            ref_url: this.oldPath,
          },
          this.staParams,
        ),
      );
    },

    getList(page, params) {
      this.listLoading = true;
      fetchList(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
          },
          params,
        ),
      ).then((response) => {
        this.list = response.data.data.records;
        this.page.total = response.data.data.total;
        this.listLoading = false;
      });
    },
    getNodeData(data) {
      deptRoleList().then((response) => {
        this.rolesOptions = response.data.data.filter((item) => {
          if (item.roleId != 13) {
            return item;
          }
        });
      });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    currentChange(current) {
      this.page.currentPage = current;
    },
    handleFilter(param, done) {
      this.page.currentPage = 1;
      this.getList(this.page, param);
      done();
      statistics(
        Object.assign(
          {
            event_name: '搜索',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },
    handleRefreshChange() {
      this.getList(this.page);
    },
    handleOpenBefore(show, type) {
      window.boxType = type;
      // 查询部门树
      fetchTree().then((response) => {
        this.treeDeptData = response.data.data;
      });
      // 查询角色列表
      deptRoleList().then((response) => {
        this.rolesOptions = response.data.data.filter((item) => {
          if (item.roleId != 13) {
            return item;
          }
        });
      });
      // 若是编辑、查看回显角色名称
      if (['edit', 'views'].includes(type)) {
        this.role = [];
        for (let i = 0; i < this.form.roleList.length; i++) {
          this.role[i] = this.form.roleList[i].roleId;
        }
      } else if (type === 'add') {
        // 若是添加角色列表设置为空
        this.role = [];
      }
      show();
    },
    handleUpdate(row, index) {
      const data = { ...row };
      data.dataScope = (data.dataScope || '').split(',').filter((i) => i);
      this.$refs.crud.rowEdit(data, index);
      this.form.password = undefined;
      this.currentStaffId = row.staffId;
    },
    create(row, done, loading) {
      addObj({ ...this.form, dataScope: this.form.dataScope?.join(',') })
        .then(() => {
          this.getList(this.page);
          done();
          /* if (row.staffId !== '') {
              insertTrAbilityQc({ id: row.staffId }).then((res) => {
                let data = res.data.data;
                if (data > 0) {
                  console.log('插表成功');
                } else {
                  this.$message.error('消息插入tr_ability_qc表失败');
                }
              });
            } */
          this.$notify.success('创建成功');
        })
        .catch(() => {
          loading();
        });
      statistics(
        Object.assign(
          {
            event_name: '添加',
            event_type: 'click',
            class_name: 'checkTrAbilityQc',
            class_url: '/dotadmin/dotadmin/qc/checkTrAbilityQc',
            event_params: '{id: row.staffId}',
          },
          this.staParams,
        ),
      );
    },
    update(row, index, done, loading) {
      const data = { ...this.form };
      data.dataScope = this.form.dataScope.join(',');
      putObj(data)
        .then(() => {
          this.getList(this.page);
          done();
          if (row.lockFlag === '9' && row.staffId !== '') {
            /* deleteTrAbilityQc({ id: row.staffId }).then((res) => {
              if (res.data.data) {
                console.log('删除tr_ability_qc表成功');
              } else {
                this.$notify.error('删除tr_ability_qc表失败');
              }
            }); */
          } else if (row.lockFlag === '0' && row.staffId !== '') {
            /* insertTrAbilityQc({ id: row.staffId }).then((res) => {
              let data = res.data.data;
              if (data > 0) {
                console.log('修改成功');
              } else {
                this.$message.error('消息修改tr_ability_qc表失败');
              }
            }); */
          }
          this.$notify.success('修改成功');
          statistics(
            Object.assign(
              {
                event_name: '编辑',
                event_type: 'click',
              },
              this.staParams,
            ),
          );
        })
        .catch(() => {
          loading();
        });
    },
    deletes(row) {
      this.$confirm(
        '此操作将永久删除该用户(用户名:' + row.username + '), 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      ).then(() => {
        delObj(row.userId)
          .then(() => {
            this.getList(this.page);
            this.$notify.success('删除成功');
          })
          .catch(() => {
            this.$notify.error('删除失败');
          });
      });
      statistics(
        Object.assign(
          {
            event_name: '删除',
            event_type: 'click',
            class_name: 'delObj',
            class_url: '/system/user/',
            event_params: '{id: row.userId}',
          },
          this.staParams,
        ),
      );
    },
  },
};
</script>
